import {Injectable} from "@angular/core";
import {Subject} from "rxjs/Subject";

@Injectable()
export class UploadService {
  // Observable string sources
  private showChangedSource = new Subject<boolean>();

  show: boolean;

  // Observable string streams
  showChange$ = this.showChangedSource.asObservable();

  // Service message commands
  changeShow(show: boolean) {
    this.show = show;

    this.showChangedSource.next(show);
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/services/uploadService.ts